import { useRef, useState } from 'react';
import type { Moment } from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers-v.6/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers-v.6/AdapterMoment';
import { TimePicker, type TimePickerProps } from '@mui/x-date-pickers-v.6/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers-v.6/timeViewRenderers';
import { when } from 'util/support';
import { LayoutCsv, withUnique } from './common';
import type { SetupValueProps, CsvValue } from '../types';
import { FormField } from '../../types';

const CsvHour = (props: SetupValueProps<CsvValue>) => {
    const {
        values,
        onChange,
    } = props;

    const openPickerIconRef = useRef<HTMLElement>(null);

    const [hour, setHour] = useState<Moment | null>(null);

    const onClick = () => {
        const { parentElement } = openPickerIconRef.current || {};

        if (parentElement instanceof HTMLElement) {
            parentElement.click();
        }
    };

    const onAccept: TimePickerProps<Moment>['onAccept'] = value => {
        when(
            value,
            () => onChange!([
                ...values[FormField.SetupValue].value,
                value!.format('H')
            ])
        );
        setHour(null);
    };

    return (
        <LayoutCsv
            {...props}
        >
            <LocalizationProvider
                dateAdapter={AdapterMoment}
            >
                <TimePicker
                    slotProps={{
                        textField: {
                            size: 'small',
                            fullWidth: true,
                            onClick
                        },
                        openPickerIcon: {
                            ref: openPickerIconRef
                        }
                    }}
                    ampm={false}
                    closeOnSelect={false}
                    label='Hour Setup Value'
                    value={hour}
                    views={['hours']}
                    onChange={setHour}
                    onAccept={onAccept}
                    viewRenderers={{
                        hours: renderTimeViewClock
                    }}
                />
            </LocalizationProvider>
        </LayoutCsv>
    );
};

export default withUnique(CsvHour);
